module.exports = __webpack_public_path__ + "static/media/logo.2dd2f2a7.png";